<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" dark :attrs="attrs" :on="on">
        <v-btn color="primary" dark v-bind="attrs" v-on="on">
          Open Dialog
        </v-btn>
      </slot>
    </template>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Confirm action</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col col="12">
              <h3>
                This will use 1 recharge token from your reseller account for an
                year of Shopman Premium Subscription for Business <b>{{business.name}}</b>
              </h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col col="12">
              <v-text-field
                label="Notes"
                color="primary"
                type="text"
                v-model="notes"
                prepend-icon="mdi-note"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">
          Close
        </v-btn>
        <v-btn color="blue darken-1" text @click="makeBusinessPremium">
          Update to Premium
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    business: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      enteredEmail: "",
      notifications: false,
      sound: true,
      widgets: false,
      selectedDiscountCode: null,
      notes: "",
    };
  },
  computed: {
    ...mapGetters({
      activeAccount: "partner/active",
    }),
  },
  methods: {
    ...mapActions({
      fetchBusinesses: "business/fetchBusinesses",
      updateBusinessToPremium: "business/subscribeViaResellerRecharge",
    }),
    async makeBusinessPremium() {
      this.dialog = false;
      try {
        this.$notifier.showMessage({
          content: "Updating..Please wait...",
        });
        await this.updateBusinessToPremium({
          account: this.activeAccount,
          business: this.business,
          notes: this.notes,
        });
        this.$notifier.showMessage({
          content: "Updated to premium",
        });
        this.fetchBusinesses({
          activeAccount: this.activeAccount,
          bid: null,
          options: null,
        });
      } catch (error) {
        this.$notifier.showMessage({
          content:
            "Update to premium failed. Error: " + error.message || "unknown",
        });
      }
    },
  },
};
</script>
